export default __webpack_public_path__ + "static/media/sample.b4f52eb6.svg";